/**
 * This file contains the default content structure for the Home page.
 * It serves as a single source of truth for both:
 * 1. Firebase initialization script
 * 2. Component default values
 */

// Hero Section Content
export const heroContent = {
  heading: "SHAMSHERSONS",
  subheading: "Quality Piano Works",
  paragraphText:
    "With the experience of nearly a century, we promise to provide our best services and expertise in a professional way.",
  buttonText: "About Shamshersons",
  buttonLink: "/about-us",
  secondaryButtonText: "Contact Us",
  secondaryButtonLink: "/enquiry",
  imageUrl: "",
  position: 1,
};

// Welcome Section Content
export const welcomeContent = {
  heading: "Welcome to Shamshersons",
  tagline: "Crafting Perfect Piano Harmony Since 1930",
  text: "For nearly a century, Shamshersons has been dedicated to the art and craft of piano excellence. From expert tuning and repairs to complete restorations, our family-owned business brings the perfect harmony back to your cherished instruments with unmatched skill and precision.",
  primaryButtonText: "Explore Our Services",
  primaryButtonLink: "/services",
  secondaryButtonText: "Our Legacy",
  secondaryButtonLink: "/about-us",
  position: 2,
};

// Highlights Section Content
export const highlightsContent = {
  heading: "Why Choose Shamshersons?",
  foundingYear: 1930,
  items: [
    {
      title: "Expert Craftsmanship",
      text: "Decades of specialized knowledge and skills passed down through generations of master piano technicians.",
      icon: "🏆",
    },
    {
      title: "Years of Excellence",
      text: "A rich heritage of piano tuning and restoration expertise since our founding in 1930.",
      icon: "⏱️",
      showYears: true,
    },
    {
      title: "Family Tradition",
      text: "A proud family business with values centered on quality, integrity, and exceptional service.",
      icon: "👨‍👩‍👧‍👦",
    },
    {
      title: "Passion for Pianos",
      text: "Deep appreciation for the art of piano music and the instruments that create these beautiful sounds.",
      icon: "❤️",
    },
  ],
  position: 3,
};

// Service Preview Section Content
export const servicePreviewContent = {
  heading: "Expert Piano Services",
  text: "From routine maintenance to complete restoration projects, our comprehensive piano services keep your instrument in perfect condition. Our expert technicians combine traditional craftsmanship with modern techniques to address all your piano needs.",
  services: [
    "Professional Piano Tuning",
    "Piano Repair & Regulation",
    "Complete Piano Restoration",
    "Cabinet Refinishing",
    "Piano Rental Services",
  ],
  buttonText: "View All Services",
  buttonLink: "/services",
  position: 4,
};

// Testimonials Section Content
export const testimonialsContent = {
  heading: "What Our Clients Say",
  testimonials: [
    {
      id: 1,
      name: "Anil Mehta",
      location: "South Delhi",
      service: "Piano Restoration",
      content:
        "Shamshersons restored my grandfather's piano to its original beauty. Their craftsmanship and attention to detail is incredible.",
      initials: "AM",
    },
    {
      id: 2,
      name: "Ravi Kapoor",
      location: "Vasant Kunj, Delhi",
      service: "Piano Tuning & Repair",
      content:
        "I've had my grand piano tuned by several technicians, but none compare to Shamshersons. They understand the nuances of tuning that others miss completely.",
      initials: "RK",
    },
    {
      id: 3,
      name: "Sunita Sharma",
      location: "Greater Kailash, Delhi",
      service: "Piano Restoration",
      content:
        "My 70-year-old Steinway has been given new life by the team at Shamshersons. The piano now sounds even better than when I first received it as a gift decades ago.",
      initials: "SS",
    },
  ],
  position: 5,
};

// Contact Preview Section Content
export const contactPreviewContent = {
  heading: "Ready to Restore Your Piano?",
  text: "Contact our team of expert piano technicians today to discuss your piano's needs and schedule a consultation. Whether you need tuning, repairs, or a complete restoration, we're here to help your instrument sound its absolute best.",
  buttonText: "Contact Us",
  buttonLink: "/enquiry",
  phoneNumber: "+919811020513",
  phoneButtonText: "Call: +91 9811020513",
  position: 6,
};

// Education Preview Section Content
export const educationPreviewContent = {
  heading: "Learn About Pianos",
  text: "Explore our educational resources to learn about different types of pianos, their history, and how to care for your instrument properly. Understanding your piano helps you make informed decisions about its maintenance and restoration.",
  buttonText: "Piano Guide",
  buttonLink: "/about-pianos",
  imageAlt: "Piano Types",
  position: 7,
};

// Complete Home Page content structure for Firebase
export const homePageContent = {
  title: "Home Page",
  content: {
    hero: heroContent,
    welcome: welcomeContent,
    highlights: highlightsContent,
    servicePreview: servicePreviewContent,
    testimonials: testimonialsContent,
    contact: contactPreviewContent,
    education: educationPreviewContent,
  },
};

export default homePageContent;
